import { useTranslate } from '../../hooks'
import { Typography } from '@repo/ui/components/typography'
import type { IOrderbookOrdersEmptyProps } from './orderbook.types'
import { Text } from '@repo/ui/components/icons'

export function OrderbookOrdersEmpty(props: IOrderbookOrdersEmptyProps) {
  const { type } = props
  const { t } = useTranslate()
  return (
    <Typography className='flex flex-col items-center justify-center py-2xl'>
      <Text className='mb-lg size-14' />
      <Typography color='text-neutral-surface-60' size='xs'>
        {t(
          `orderbook_no${type === 'all' ? '' : `_${type}`}_orders` as keyof typeof t,
        )}
      </Typography>
    </Typography>
  )
}
